import * as React from "react";
import classnames from "classnames";
import { ITextInputElement } from "@graffer-inc/form-schema";
import { TextButton } from "@graffer-inc/console-design-kit";
import { TenantProcessResultInputElementValidator } from "@graffer-inc/cloud-gov-core";

import { ErrorMessage } from "./../../../../atoms/error-message";
import { useModal } from "../../../../../utils/custom-hooks";
import { TenantProcessResultDetailModal } from "../../modals/tenant-process-result-detail-modal";

type TenantProcessResultInputElementRowProps = {
  isReadonly: boolean;
  rowIndex: number;
  element: ITextInputElement;
  onUpdate: (index: number, element: ITextInputElement) => void;
  onDelete: (index: number) => void;
};

export const TenantProcessResultInputElementRow: React.FC<
  TenantProcessResultInputElementRowProps
> = ({ element, onUpdate, onDelete, rowIndex, isReadonly }) => {
  const validator = new TenantProcessResultInputElementValidator(element);
  const [touched, setTouched] = React.useState<{
    label?: boolean;
    description?: boolean;
    validations?: boolean;
  }>({});
  const detailModal = useModal();
  return (
    <tr className="has-text-left">
      <td
        style={{
          border: "none",
        }}
      >
        <div className="field">
          <p className="control">
            {isReadonly ? (
              <div className="is-vcentered">{element.label.text}</div>
            ) : (
              <input
                className={classnames("input", {
                  "is-danger": touched.label && validator.label(),
                })}
                value={element.label.text}
                placeholder="（例：受験番号）"
                onChange={(e) => {
                  onUpdate(rowIndex, {
                    ...element,
                    label: {
                      ...element.label,
                      text: e.target.value,
                    },
                  });
                }}
                onBlur={() => setTouched({ ...touched, label: true })}
              />
            )}
          </p>
        </div>
        <ErrorMessage msg={touched.label ? validator.label() : undefined} />
      </td>
      <td
        style={{
          border: "none",
        }}
      >
        <div className="field">
          <p className="control">
            {isReadonly ? (
              <div className="is-vcentered">{element.description.text}</div>
            ) : (
              <input
                className={classnames("input", {
                  "is-danger": touched.description && validator.description(),
                })}
                value={element.description.text}
                placeholder="（例：Excelで生成した11桁の番号）"
                onChange={(e) => {
                  onUpdate(rowIndex, {
                    ...element,
                    description: {
                      ...element.label,
                      text: e.target.value,
                    },
                  });
                }}
                onBlur={() => setTouched({ ...touched, description: true })}
              />
            )}
          </p>
        </div>
        <ErrorMessage
          msg={touched.description ? validator.description() : undefined}
        />
      </td>
      <td
        style={{
          border: "none",
        }}
      >
        <TextButton
          text={element.validations.length > 0 ? "設定済" : "未設定"}
          icon="ArrowRightIcon"
          onClick={() => detailModal.open()}
        />
        {detailModal.isActive && (
          <TenantProcessResultDetailModal
            isActive={detailModal.isActive}
            element={element}
            isReadonly={isReadonly}
            touched={touched.validations}
            setTouched={() => setTouched({ ...touched, validations: true })}
            onClose={detailModal.close}
            onUpdate={(e: ITextInputElement) => onUpdate(rowIndex, e)}
          />
        )}
      </td>
      <td
        className="is-vcentered"
        style={{
          border: "none",
        }}
      >
        {!isReadonly && (
          <button
            className="delete is-large"
            onClick={() => {
              onDelete(rowIndex);
            }}
          />
        )}
      </td>
    </tr>
  );
};
